import React, { useEffect, useState } from 'react';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import Input from '../../../../components/elements/form/input';
import Teaxtarea from '../../../../components/elements/form/textarea';
import SelectBox from '../../../../components/elements/form/selectBox';
import { DropdownOptionType, Option } from '../../../../_config/types';
import Datepicker from '../../../../components/elements/form/datepicker';
import  Button  from '../../../../components/elements/button';
import { AgGridReact } from 'ag-grid-react';
import { useFacilitiesApi } from '../../../../store/api/hooks/facilitiesApiHook';
import { useCommonApi } from '../../../../store/api/hooks/commonApiHook';
import { useSpearPartsApi } from '../../../../store/api/hooks/spearPartsApiHook';
import { useCycleCountApi } from '../../../../store/api/hooks/cycleCountApiHook';
import toast from 'react-hot-toast';
import { getSelectedOption } from '../../../../_common/functions';
import { useFacilityManagersSelector } from '../../../../store/selectors/masterSelector';
import { useWorkOrderApi } from '../../../../store/api/hooks/workOrderApiHook';
import { useAppLoader } from '../../../../_common/pageLoader/appLoaderHook';
import Label from '../../../../components/elements/form/fromLabel';
interface Props {
	_ref?: any;
	viewData?: any;
	onCreate?: () => void;
	onCancel?: () => void;
	partDetails?: any;
}

type FormValues = {
    pickedByID: any;
    facilityID:any;
    subFacilityID:any;
    drop: DropdownOptionType;
    pickNote: any;
    purchaseDate: Date;
};

const yourConstant = 'someValue';

const ViewStockpicking: React.FC<Props> = ({
	_ref,
	viewData,
	onCreate = () => { },
	onCancel = () => { },
	partDetails
}) => {
    const {control, register, handleSubmit,setValue,trigger,reset,watch, formState: { errors } } = useForm<FormValues>();

    const [facilityoption, setFacilityoption] = useState<any>(null);
        const [subfacilitylist, setsubfacilityoption] = useState<any>([]);
        const [cycleCountCode, setCycleCountCode] = useState<any>(null);
        const [partstatus, setPartStatus] = useState<boolean>(false);
		const { showLoader, hideLoader } = useAppLoader();
        const [scanCode, setScanCode] = useState<string>('');
        const [parts, setParts] = useState<any>([]);
              const [stockDetails, setStockDetails] = useState<any>([]);
        const facilityApi: any = useFacilitiesApi();
        const commonApi: any = useCommonApi();
        const spearPartsAPI = useSpearPartsApi();
        const cycleCountAPI = useCycleCountApi();
		const workOrderAPI: any = useWorkOrderApi();
	

        const users = useFacilityManagersSelector();
            const facilityWatch = watch("facilityID");
            const subFacilityWatch =watch('subFacilityID');
        
            const getfacilitylist = () => {
                const payload = {};
                facilityApi.getFacilityList(
                    payload,
                    (resp: any) => {
                        let facilitylist: any = [];
                        resp.facilityList.map((facilist: any) => {
                            facilitylist.push({
                                label: facilist.facilityName,
                                value: facilist.facilityID,
                                data: facilist,
                            });
                        });
                        setFacilityoption(facilitylist);
                    },
                    (error: any) => {
                        console.log("error =>", error);
                        toast.error(error);
                    }
                );
            };
        
            const getsubfacilityList = (_facilityID: any) => {
                const payload = { facilityID: _facilityID };
                facilityApi.getSubFacilityList(
                    payload,
                    (resp: any) => {
                        let subfacilityoption: any = resp?.subFacilityList?.map(
                            (countylist: any) => {
                                return {
                                    label: `${countylist.subFacilityTypeName} - ${countylist.no}`,
                                    value: countylist.subFacilityID,
                                };
                            }
                        );
                        setsubfacilityoption(subfacilityoption);
        
                        if(viewData){
                            setValue("subFacilityID", getSelectedOption(viewData?.subFacilityID, subfacilityoption));
                        }
        
                    },
                    (error: any) => {
                        console.log("error =>", error);
                        setsubfacilityoption([]);
                        toast.error(error);
                    }
                );
            };
        
            const getCycleCountCode = () => {
                const payload = {};
                cycleCountAPI.GetID(
                    payload,
                    (resp: any) => {
        
                        setCycleCountCode(resp.code);
                    },
                    (error: any) => {
                        console.log("error =>", error);
                        toast.error(error);
                    }
                );
            };
        
            useEffect(() => {
                if (users == null) {
                    commonApi.GetUserList(
                        {
                            pageNo: 1,
                            pageSize: 1000,
                        },
                        (resp: any) => { },
                        (error: any) => { }
                    );
                }
            }, [users]);
        
            useEffect(() => {
                if (facilityWatch) {
                    setValue("subFacilityID", null);
                    getsubfacilityList(facilityWatch.value);
                }
            }, [facilityWatch]);
        
            const formReset = () => {
                reset({
                 
                  
                 
                    facilityID: '',
                    subFacilityID: ''
        
                });
                setParts([])
                setPartStatus(false)
            };
        
            useEffect(() => {
                if (_ref?.current) {
                    _ref.current.reset = formReset;
                }
            }, [_ref]);
            	const addScanCode = (code:string) => {
		spearPartsAPI.getSpearPartsList(
			{
				pageSize: 20,
				pageNumber: 1,
				searchParam: code,
			},
			(data: any) => {
				if(data?.sparePartsList?.length > 0){
					let partOption = {
						label: data?.sparePartsList[0].sparePartsName + ` (${data?.sparePartsList[0].partsCode})`,
						value: data?.sparePartsList[0].partsID,
						partDetails: data?.sparePartsList[0],
					};

					cycleCountAPI.GetStockCount(
						{
							partID: partOption.value,
							facilityID: facilityWatch?.value,
							subFacilityID:subFacilityWatch?.value
						},
						(resp: any) => {
							let alreadyAdded = false;

							setParts(parts.map((part:any)=>{
								if(part.partDetails?.partsCode == partOption.partDetails?.partsCode){
									alreadyAdded = true
									return {...part,qty: Number(part.qty) + 1}
								} else {
									return part
								}
							}))
							if (!alreadyAdded) {
								setParts([
									...parts,
									{
										...partOption,
										currentStock: resp?.currentStock || 0,
										qty: 1
									},
								]);
							}
						},
						(error: any) => {
							setParts([...parts, { ...partOption, currentStock: 0 }]);
						}
					);
				} else {
					toast.error("No spare part found")
				}
			},
			(error: any) => {
				toast.error("No spare part found")
			}
		);
	}
       const getCurrentStock = (partID: any, facilityID: any, subFacilityID: any) => {
      return new Promise((resolve, reject) => {
        if (subFacilityID && subFacilityID !== null && subFacilityID !== undefined && subFacilityID !== 0) {
          cycleCountAPI.GetStockCount(
            { partID, facilityID, subFacilityID },
            (resp: any) => {
              resolve(resp?.currentStock || 0);
            },
            (error: any) => {
              console.error("Error fetching current stock:", error);
              reject(error);
            }
          );
        } else {
          cycleCountAPI.GetStockCount(
            { partID, facilityID },
            (resp: any) => {
              resolve(resp?.currentStock || 0);
            },
            (error: any) => {
              console.error("Error fetching current stock:", error);
              reject(error);
            }
          );
        }
      });
    }
	useEffect(() => {
		if (facilityoption) {
			console.log('facilityoption', viewData);
			if (!viewData) {
				getCycleCountCode();
			} else {
				setPartStatus(true);
				setCycleCountCode(viewData?.inventoryCycleCountCode);
				setValue("facilityID", getSelectedOption(viewData?.facilityID, facilityoption ? facilityoption : []));
				setValue("purchaseDate", viewData?.addedDate);
                setValue("pickedByID", getSelectedOption(viewData?.addedBy, users ? users : []));
                
				//setValue("operatorID", getSelectedOption(viewData?.operatorID, users ? users : []));
				//setValue("cycleCountNotes", viewData?.cycleCountNotes);
				cycleCountAPI.GetStockPickingDetails({StockPickID:viewData?.stockPickID},(resp: any) => {
                    console.log("resp=======",resp);

				const stockDetailsPromise = resp?.stockPickDetailsList?.map((part: any) => {
    return Promise.all([getCurrentStock(part?.partsID, viewData?.facilityID, viewData?.subFacilityID)])
        .then(([currentStock]) => {
            return {
                label: `${part?.partsName} (${part?.partsCode})`,
                value: part?.partsID,
                id: part?.partsID,
                partDetails: {
                    sparePartsName: part?.partsName,
                    partsCode: part?.partsCode,
                    costPerUnit: part?.partsCostRate,
                    unitID: part?.unitID
                },
                currentStock: currentStock || 0,
                qty: part?.pickQuantity,
            };
        })
        .catch((error) => {
            console.error('Error fetching current stock:', error);
            throw error; // Propagate the error further if needed
        });
});

Promise.all(stockDetailsPromise)
    .then((stockDetails) => {
        console.log('Stock details:', stockDetails);
          setParts(stockDetails);
        // Further processing or assignment of stockDetails
    })
    .catch((error) => {
        console.error('Error fetching stock details:', error);
    });
                  
setStockDetails(resp)
					console.log("return resp--------", resp);
					//setParts(resp?.cycleCountDetails)
				}
				,(error: any) => {
					console.log("error =>", error);
					toast.error(error);
				});
				/* 
				cycl
				
				
				
				setParts(viewData?.cycleCountDetails) */
			}
		}
		
	}, [viewData, facilityoption,users]);
        
        const onSubmit: SubmitHandler<FormValues> = data => {
            console.log(data);

			// "partsID": part.partDetails.partsID,
            //         "stockOnHand": part.currentStock,
            //         "adjustedQuantity": ((Number(part.in_stock??0)+Number(part.currentStock??0))-Number(part.out_stock??0)),
            //         "partsCostRate": part.partDetails.costPerUnit,
            //         "partsTotalAmount": ((Number(part.in_stock??0)+Number(part.currentStock??0))-Number(part.out_stock??0)) * parseFloat(part.partDetails.costPerUnit),
            //         "partsTotalAmountLocal": ((Number(part.in_stock??0)+Number(part.currentStock??0))-Number(part.out_stock??0)) * parseFloat(part.partDetails.costPerUnit),
            //         "exchangeRate": 1,
            //         "currencyID": 1,
            //         "unitID": part.partDetails.unitID

			 let payload: any = {
            facilityID: data?.facilityID?.value,
            subFacilityID: data?.subFacilityID?.value || null,
              pickNo: Date.now(), // or generate a unique pick number if needed
          pickingDate: new Date().toISOString(),
            pickedByID: data?.pickedByID?.value,
			pickNote: data.pickNote
			
,
        
            stockPickDetails: parts.map((part: any) => {
                return {
                     partsID: part.partDetails.partsID, // assuming partsID is available in part object
                 pickQuantity:+part.qty, // assuming you want to pick the required quantity
                partsCostRate:  part.partDetails.avgUnitCost || 0, // assuming you have a cost rate in the part object
               partsTotalAmount: (( part.partDetails.avgUnitCost || 0) * part.qty), // calculate the total amount
                 unitID: part.partDetails.unitID || 0, // assuming you have unitID in the part object
                }
            })

        }

		   const payloadpicking :any ={}
     payloadpicking.request =payload

		console.log("payload",payload);
  showLoader();
		  workOrderAPI.InsertStockPicking(
        payloadpicking,
        (resp: any) => {
           onCreate();
            onCancel();
            console.log(resp, "Submited resp")
            toast.success(resp?.message)
            formReset();
            hideLoader();
        },
        (error: any) => {
       console.log('error =>', error);
            hideLoader();
            toast.error(error);
        }
      );
        };
        
        useEffect(() => {
            getfacilitylist();
        }, []);

    return (
         <form onSubmit={handleSubmit(onSubmit)}>
            <div className='pt-4'>
                <div className="grid grid-cols-2 gap-4">
                    <div className='bg-green-50 py-2 px-3'>
                        <h6 className='text-[0.813rem] font-semibold'>Pick No</h6>
                        <p className='text-[0.813rem] font-normal mt-2'>{viewData? viewData?.pickNo :Date.now()}</p>
                    </div>
                    <div className='bg-green-50 py-2 px-3'>
                        <h6 className='text-[0.813rem] font-semibold'>Date and Time</h6>
                        <p className='text-[0.813rem] font-normal mt-2'>{ viewData? viewData?.pickingDate:new Date().toISOString()}</p>
                    </div>
                </div>
                <div className='grid grid-cols-2 gap-2'>
                        <Controller
                                    name='pickedByID'
                                    control={control}
                                 
                                    	rules={{ required: "Picked By is required" }}
                                    render={({ field :{value,onChange} }) => (
                                        <SelectBox 
                                        label='Picked By'
                                           disabled={true}
                                        value={value}
                                        onChange={onChange}
                                        required
                                        placeholder='Picked By'
                                       options={users ? users : []}
                                        className='mb-0'
                                        	error={errors.pickedByID?.message as any}
                                        />
                                    )}
                                />
                            
                         
                </div>
                      <Controller
						name="facilityID"
						control={control}
						rules={{ required: "Facility is required" }}
						render={({ field: { value, onChange } }) => (
							<SelectBox
								label="Select Facility"
								value={value}
								disabled={partstatus}
								onChange={onChange}
								required
								placeholder="Choose Facility"
								options={facilityoption}
								className="mb-0"
								error={errors.facilityID?.message as any}
							/>
						)}
					/>
					<Controller
						name="subFacilityID"
						control={control}
						//  rules={{ required: "SubFacility is required" }}
						render={({ field: { value, onChange } }) => (
							<SelectBox
								label="Select Sub Facility"
								value={value}
								disabled={partstatus}
								onChange={onChange}
								//   required
								placeholder="Choose Sub Facility"
								options={subfacilitylist}
								className="mb-0"
							/>
						)}
					/>
              
             	
			{partstatus && (
				<>
					

					<div className="rounded-md border border-gray-300 mt-3">
						<div className="grid grid-cols-12 gap-1 bg-gray-100">
							<div className="col-span-3 px-2 leading-10 ">
								<label className="text-[0.75rem] font-medium text-slate-600">
									Part Code
								</label>
							</div>
							<div className="col-span-3 px-2 leading-10">
								<label className="text-[0.75rem] font-medium text-slate-600">
									Part Name
								</label>
							</div>
							<div className="col-span-3 px-2 leading-10">
								<label className="text-[0.75rem] font-medium text-slate-600">
									Available QTY
								</label>
							</div>
							<div className="col-span-3 px-2 leading-10">
								<label className="text-[0.75rem] font-medium text-slate-600">
									Pick  Qty
								</label>
							</div>
						</div>
						{parts.map((part: any, index: any) => (
							<div
								className="grid grid-cols-12 gap-1 text-slate-800"
								key={index}
							>
								<div className="col-span-3 px-2 leading-10 flex items-center">
									{part?.partDetails?.partsCode}
								</div>
								<div className="col-span-3 px-2 leading-10 flex items-center">
									<label className="text-[0.75rem] font-normal">
										{part?.partDetails?.sparePartsName}
									</label>
								</div>
								<div className="col-span-3 px-2 leading-10 flex items-center">
									<label className="text-[0.75rem] font-normal text-center w-full">
										{part?.currentStock}
									</label>
								</div>
								<div className="col-span-3 px-2 leading-10 flex items-center">
										{part?.qty}
								</div>
							</div>
						))}
					</div>
				</>
			)}
                
              <div className='mt-2'>
                                  <Label text='Note' required={false} />
                                  <p className='text-[0.85rem] italic font-normal mt-1'>{viewData?.pickNote}</p>
                              </div>
               
                <hr className='border-gray-900 my-6' />
            </div>
          <div className='flex justify-end gap-2'>
                {/* <Button  type="submit" disabled={parts.length == 0 ? true : false}>Save</Button> */}
                <Button theme='secondary'onClick={() => {
						onCancel();
						formReset();
					}}>Cancel</Button>
            </div>  

           
        </form>
    );
};

export default ViewStockpicking;
